import * as yup from 'yup';
import formValidator from 'tools/form-validator';
import * as cpf from '@fnando/cpf';
import moment from 'moment';

const validator = yup.object().shape({
  cus_nome_razao_social_0: yup
    .string()
    .trim()
    .max(100)
    .matches(/^[A-zÀ-ÿ']+\s([A-zÀ-ÿ']\s?)*[A-zÀ-ÿ][A-zÀ-ÿ']+$/, { excludeEmptyString: true, message: 'O nome informado é inválido' })
    .required('Informe seu nome completo'),
  cus_email_0: yup
    .string()
    .email('O e-mail informado é inválido')
    .required('Informe seu e-mail'),
  cus_data_nascimento_fundacao_0: yup
    .mixed()
    .nullable()
    .test('isValidDate', 'Informe uma data válida', (value) => {
      const isValid = moment(value, 'DD/MM/YYYY').isValid();
      const isMax100 = moment(value, 'DD/MM/YYYY').add(100, 'years').isAfter(moment());

      return isValid && isMax100;
    })
    .test('isMajority', 'Você deve ser maior de 18 anos', (value) => moment().isAfter(moment(value, 'DD/MM/YYYY').add('18', 'years')))
    .required('Informe sua data de nascimento'),
  cus_cpf_cnpj_0: yup
    .mixed()
    .when('membro_exterior', {
      is: 'S',
      otherwise: yup.mixed()
        .required()
        .test('cpf', 'O número do CPF informado não é válido', (value) => cpf.isValid(value)),
    }),
  cus_celular_0: yup
    .string()
    .min(8, 'Informe um número de celular válido')
    .max(20, 'Informe um número de celular válido')
    .nullable()
    .required('Informe seu celular'),
});

export default formValidator(validator);
